import * as React from 'react';

import TroubleShootingTools32 from './TroubleShootingTools32';

export const troubleShootingTools32 = () => <TroubleShootingTools32 />;

export default {
    title: 'Icon/Logo/TroubleShootingTools32',
    component: TroubleShootingTools32,
    parameters: {
        notes: "`import TroubleShootingTools32 from 'box-ui-elements/es/icon/logo/TroubleShootingTools32';`",
    },
};
